import type { Reason } from "@zooi/contracts";
export { personalWorkspaceName, signInCodeEmail, workspaceInvitationEmail } from "./auth.ts";
export { RETIRED_PAGE_LABELS, renderRetiredPage } from "./retired-pages.ts";

// Rendered emails and browser action titles share names and source handling.
export const PLATFORM: Readonly<Record<string, string>> = {
  hackernews: "Hacker News",
  reddit: "Reddit",
  stackexchange: "Stack Exchange",
  x: "X",
  github: "GitHub",
  web: "the web",
};

export const LINK_SOURCE: Readonly<Record<string, string>> = {
  posthog: "PostHog",
  plausible: "Plausible",
  zooi: "your early-access page",
};

const text = (reason: Reason, key: string) => String(reason.params?.[key] ?? "");

/** Source content stays exact. Unknown codes belong to their caller's UI. */
export function actionTitleText(title: Reason): string | null {
  if (title.code === "source_text") return text(title, "text");
  if (title.code !== "answer_discussion" && title.code !== "answer_comment") return null;
  const platform = text(title, "platform");
  const subject = text(title, "subject");
  const where = (platform === "reddit" || platform === "stackexchange") && subject ? subject : PLATFORM[platform] ?? platform;
  return `${title.code === "answer_comment" ? "Answer a comment on" : "Answer on"} ${where}: “${text(title, "title")}”`;
}

export function dailyDigestEmail({ productName, url, items }: {
  productName: string;
  url: string;
  items: { title: Reason; status: string }[];
}): { subject: string; text: string } {
  const labels: Record<string, string> = { committed: "Post it yourself", failed: "Fix the link", reading_due: "Confirm the reading" };
  const lines = items.map((item) => `- ${labels[item.status] ?? "Review this action"}: ${actionTitleText(item.title) ?? "Action"}`);
  const count = new Intl.NumberFormat("en-US").format(items.length);
  return {
    subject: `${count} ${items.length === 1 ? "thing needs" : "things need"} you today on ${productName}`,
    text: `${lines.join("\n")}\n\nOpen Today: ${url}\n\nYou get this only on days something needs you. Turn it off in the product settings.`,
  };
}
